import SodSidePanelUser from './SodSidePanelUser';

export default SodSidePanelUser;
